import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'admin', 'customer', 'errors'],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      // Order of detection: localStorage → browser language → fallback
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // Map browser language variants to our supported languages
      convertDetectedLanguage: (lng: string) => {
        // Map Arabic variants to 'ar'
        if (lng.startsWith('ar')) {
          return 'ar'
        }
        // Map English variants to 'en'
        if (lng.startsWith('en')) {
          return 'en'
        }
        // Default to English for other languages
        return 'en'
      },
    },
  })

export default i18n

